import { qcAxios } from '../../../../../api/axiosQcClient';

const API_PREFIX = '/api';
const VIEW = 'REVIEWER';

function normalizeWorkflowList(payload) {
  const items = payload?.data;
  if (!Array.isArray(items)) return [];
  return items.filter((item) => Boolean(item?.workflow_id));
}

export async function getUserWorkflows(reqStatus) {
  const { data } = await qcAxios.get(`${API_PREFIX}/wf/getUserWorkflows`, {
    params: {
      view: VIEW,
      req_status: reqStatus,
    },
  });
  return normalizeWorkflowList(data);
}
